module.exports = __webpack_public_path__ + "media/images/icon-subtract-outline-f23edba7657ea00e22f09171312defd0.svg";